import { type ActionArgs } from 'xstate';

import { type PaymentStatePollingContext } from './payment-state-polling-machine.context';
import { type PaymentStatePollingEvent } from './payment-state-polling-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

const paymentStatePolling: Delay = ({ context }) => context.pollingConfiguration.paymentStatePollingInterval; // prettier-ignore
const paymentStateDelayedTolerance: Delay = ({ context }) => context.pollingConfiguration.paymentStateDelayedTolerance; // prettier-ignore

// ─────────────────────────────────────────────────────────────────────────────

export const PaymentStatePollingDelays = {
  paymentStatePolling,
  paymentStateDelayedTolerance,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Delay = (
  args: ActionArgs<PaymentStatePollingContext, PaymentStatePollingEvent, PaymentStatePollingEvent>,
) => number;
